import type { NavLink, SiteConfig, SocialLink } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "آموزا",
    latinName: 'Amooza',
    tagline: "یادگیری تعاملی با هوش مصنوعی",
    description: "آموزا پلتفرم آموزش تعاملی با هوش مصنوعی است: دوره‌ها را در وب کشف کنید، در اپلیکیشن دسکتاپ با اسلایدهای پویا و مربی هوشمند بیاموزید و پیشرفتتان را در داشبورد دنبال کنید.",
    url: getOrigin()
}

export const navLinks: Array<NavLink> = [
    { label: "خانه", href: '/', match: 'home' },
    { label: "دوره‌ها", href: '/courses', match: 'courses' },
    { label: "ویژگی‌ها", href: '/#features', match: 'features' },
    { label: "چطور کار می‌کند", href: '/#how-it-works', match: 'how-it-works' },
    { label: "جامعه", href: '/#community', match: 'community' }
]

export const socialLinks: Array<SocialLink> = [
    { label: "تلگرام", href: 'https://t.me', network: 'telegram' },
    { label: "اینستاگرام", href: 'https://www.instagram.com', network: 'instagram' },
    { label: "لینکدین", href: 'https://www.linkedin.com', network: 'linkedin' },
    { label: "یوتیوب", href: 'https://www.youtube.com', network: 'youtube' }
]

export const footerColumns: Array<{ title: string, links: Array<{ label: string, href: string }> }> = [
    {
        title: "پلتفرم",
        links: [
            { label: "همه دوره‌ها", href: '/courses' },
            { label: "ویژگی‌های هوش مصنوعی", href: '/#features' },
            { label: "اپلیکیشن دسکتاپ", href: '/#desktop-app' },
            { label: "چطور کار می‌کند", href: '/#how-it-works' }
        ]
    },
    {
        title: "حساب کاربری",
        links: [
            { label: "ورود", href: '/login' },
            { label: "ثبت‌نام رایگان", href: '/signup' },
            { label: "داشبورد", href: '/dashboard' },
            { label: "ساخت دوره با هوش مصنوعی", href: '/#community' }
        ]
    },
    {
        title: "پشتیبانی",
        links: [
            { label: "تماس با ما", href: '/contact' },
            { label: "قوانین و شرایط استفاده", href: '/terms' },
            { label: "حریم خصوصی", href: '/privacy' }
        ]
    }
]
